import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { palette, FONT } from '../../styles/tourTheme';
import { formatDateLong } from '../../utils/calendarContacts';
import { DayNotesEditor } from './DayNotesEditor';

export function MasterTourNotesPage({
  notesText = '',
  venueName,
  cityLine,
  dateKey,
  isDarkMode,
  accent,
  theme,
  onPersist,
  canEdit = true,
}) {
  const pal = palette(isDarkMode);
  const hue = accent || pal.teal;

  return (
    <View style={{ backgroundColor: pal.page, padding: 24, paddingBottom: 48, width: '100%' }}>
      <View style={{ borderBottomWidth: 2, borderBottomColor: hue, paddingBottom: 14, marginBottom: 22 }}>
        <Text style={[styles.label, { color: pal.mute, marginBottom: 5 }]}>Notes</Text>
        <Text style={[styles.heroSm, { color: pal.ink }]}>{venueName || 'Day notes'}</Text>
        <Text style={{ color: pal.mute, marginTop: 4 }}>
          {[cityLine, formatDateLong(dateKey)].filter(Boolean).join(' · ') || 'Pick a show day.'}
        </Text>
      </View>
      <View style={[styles.card, { backgroundColor: pal.surf, borderColor: pal.line }]}>
        {canEdit && theme ? (
          <DayNotesEditor
            variant="tour"
            pal={pal}
            isDarkMode={isDarkMode}
            value={notesText}
            onChange={(text) => onPersist?.(text)}
            theme={theme}
            placeholder="Notes for this day — aftershow, crew, anything the party needs"
            inputMinHeight={360}
          />
        ) : (
          <Text style={{ color: pal.inkSoft, fontSize: 15, lineHeight: 23 }}>
            {String(notesText || '').replace(/<[^>]+>/g, '').trim() || 'No notes for this day yet.'}
          </Text>
        )}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  label: { fontFamily: FONT.mono, fontSize: 12, letterSpacing: 1.2, textTransform: 'uppercase' },
  heroSm: { fontSize: 27, fontWeight: '700', letterSpacing: -0.4 },
  card: { borderWidth: 1, borderRadius: 12, padding: 18 },
});
